module.exports = __webpack_public_path__ + "img/47-green.19ab9d4f.svg";